document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('[data-slider]').forEach((slider) => {
		const slides = Array.from(slider.querySelectorAll('.slider-track > li'));
		const thumbs = Array.from(slider.querySelectorAll('.slider-thumbs > li'));
		const prevBtn = slider.querySelector('.slider-prev');
		const nextBtn = slider.querySelector('.slider-next');

		if (slides.length < 2) return;

		let current = 0;

		const show = (index) => {
			current = (index + slides.length) % slides.length;
			slides.forEach((slide, i) => slide.classList.toggle('is-active', i === current));
			thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === current));
		};

		thumbs.forEach((thumb, i) => {
			thumb.addEventListener('click', () => show(i));
		});
		prevBtn?.addEventListener('click', () => show(current - 1));
		nextBtn?.addEventListener('click', () => show(current + 1));
	});
});
